export const getProjectType = (projectType: string) => {
  switch (true) {
    case projectType === 'workspace':
      return 'Workspace';
    case projectType === 'information_request':
      return 'Request Project';
  }
};
